<template>
  <v-col cols="12">
    <div>
      <naj-box
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.sectionTitle"
      >
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.deedId"
              :value.sync="formModel.deedId"
              :disabled="isChecking || viewMode"
              validates="required|numeric"
              @input="deedIdChanged"
            ></naj-input>
          </v-col>

          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.date"
              :label="locales.deedDate"
              :value.sync="formModel.deedDate"
              :disabled="isChecking || !formModel.deedId || viewMode"
              validates="required"
              @change="deedDateChanged"
            ></naj-input>
          </v-col>

          <v-col
            cols="4"
            align-self="center"
            class="text-right"
          >
            <naj-button
              v-if="isCheckButtonVisible"
              square
              :loading="isChecking"
              :disabled="isCheckButtonDisabled"
              @click="check"
            >
              {{ local.personInformation.check }}
            </naj-button>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <div>
      <naj-dynamic-form
        :form-model="formModel"
        :form-fields="form.fields"
        :view-mode="viewMode"
      ></naj-dynamic-form>
    </div>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'JointRealEstateDivisionDeedInfo',
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    hideNajBox: {
      type: Boolean,
      required: false,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isRetrieved: false,
      isChecking: false,
      isManual: false,
      form: {
        'id': 134,
        'name': 'JointRealEstateDivision',
        'label': 'بيانات العقار (قسمة عقارات مشتركة)',
        'description': 'بيانات العقار (قسمة عقارات مشتركة)',
        'isCustom': false,
        'customComponentName': null,
        'fields': [
          {
            'typeId': 1,
            'name': 'ownerName',
            'label': 'اسم المالك',
            'columnSize': 3,
            'sortIndex': 1,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'اسم المالك',
            'fields': [],
          },
          {
            'typeId': 1,
            'name': 'source',
            'label': 'مصدر الصك',
            'columnSize': 3,
            'sortIndex': 2,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'مصدر',
            'fields': [],
          },
          {
            'typeId': 2,
            'name': 'instrumentNumber',
            'label': 'رقم الصك',
            'columnSize': 3,
            'sortIndex': 3,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'رقم الصك',
            'fields': [],
          },
          {
            'typeId': 3,
            'name': 'instrumentDate',
            'label': 'تاريخ الصك',
            'columnSize': 3,
            'sortIndex': 4,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'تاريخ الصك',
            'fields': [],
          },
          {
            'typeId': 2,
            'name': 'pieceNumber',
            'label': 'رقم القطعة',
            'columnSize': 4,
            'sortIndex': 5,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'رقم القطعة',
            'fields': [],
          },
          {
            'typeId': 2,
            'name': 'blockNumber',
            'label': 'رقم البلوك',
            'columnSize': 4,
            'sortIndex': 6,
            'properties': '{"validations":{},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'رقم البلوك',
            'fields': [],
          },
          {
            'typeId': 2,
            'name': 'organizationalChartNumber',
            'label': 'رقم المخطط التنظيمي',
            'columnSize': 4,
            'sortIndex': 7,
            'properties': '{"validations":{},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'رقم المخطط التنظيمي',
            'fields': [],
          },
          {
            'typeId': 1,
            'name': 'district',
            'label': 'الحي',
            'columnSize': 4,
            'sortIndex': 8,
            'properties': '{"validations":{"required":"true"},"dateConfig":{},"dataGridConfig":null}',
            'description': 'الحي',
            'fields': [],
          },
          {
            'typeId': 4,
            'name': 'cityType',
            'label': 'نوع المدينة',
            'columnSize': null,
            'sortIndex': 9,
            'properties': '{"validations":{"required":"true"},"dateConfig":{},"externalDataSource":{},"textName":"cityTypeName","pickListId":48,"dataGridConfig":null,"dataSource":[{"key":1,"value":"مدينة","id":1,"name":"مدينة","statusId":1},{"key":2,"value":"محافظة","id":2,"name":"محافظة","statusId":1},{"key":3,"value":"مركز","id":3,"name":"مركز","statusId":1},{"key":4,"value":"قرية","id":4,"name":"قرية","statusId":1},{"key":5,"value":"هجرة","id":5,"name":"هجرة","statusId":1}]}',
            'description': 'نوع المدينة',
            'fields': [],
          },
          {
            'typeId': 4,
            'name': 'city',
            'label': 'المدينة',
            'columnSize': null,
            'sortIndex': 10,
            'properties': '{"validations":{"required":"true"},"dateConfig":{},"externalDataSource":{"module":"/administration/api","requestType":"get","endpoint":"/lookups/cities"},"textName":"cityName","dataGridConfig":null}',
            'description': 'المدينة',
            'fields': [],
          },
          {
            'typeId': 2,
            'name': 'space',
            'label': 'المساحة الإجمالية',
            'columnSize': 4,
            'sortIndex': 11,
            'properties': '{"validations":{"required":"true"},"dateConfig":{},"dataGridConfig":null}',
            'description': 'المساحة الإجمالية',
            'fields': [],
          },
          {
            'typeId': 4,
            'name': 'measurement',
            'label': 'وحدة القياس',
            'columnSize': 4,
            'sortIndex': 12,
            'properties': '{"validations":{"required":"true"},"dateConfig":{},"disabledIf":"","externalDataSource":{},"pickListId":74,"dataGridConfig":null,"dataSource":[{"key":1,"value":"متراً مربعاً","id":1,"name":"متراً مربعاً","statusId":1},{"key":2,"value":"أخرى","id":2,"name":"أخرى","statusId":1}],"textName":"measurementName"}',
            'description': 'وحدة القياس',
            'fields': [],
          },
          {
            'typeId': 1,
            'name': 'measurementText',
            'label': 'وحدة القياس',
            'columnSize': 4,
            'sortIndex': 13,
            'properties': '{"validations":{"conditionalRequired":"obj.measurement == 2"},"dateConfig":{},"disabledIf":"obj.measurement != 2","dataGridConfig":null}',
            'description': 'وحدة القياس',
            'fields': [],
          },
          {
            'typeId': 7,
            'name': 'claimantshareStatement',
            'label': 'بيان نصيب المدعي من العقار',
            'columnSize': 12,
            'sortIndex': 14,
            'properties': '{"validations":{"required":"true"},"dateConfig":{},"externalDataSource":{},"pickListId":177,"dataGridConfig":null,"dataSource":[{"key":1,"value":"نسبة مئوية","id":1,"name":"نسبة مئوية","statusId":1},{"key":2,"value":"مساحة مشاعة","id":2,"name":"مساحة مشاعة","statusId":1}]}',
            'description': 'بيان نصيب المدعي من العقار',
            'fields': [],
          },
          {
            'typeId': 2,
            'name': 'percentage',
            'label': 'نسبة مئوية',
            'columnSize': 3,
            'sortIndex': 15,
            'properties': '{"validations":{"conditionalRequired":"obj.claimantshareStatement == 1","isValid":"\'لا يمكن أن تكون النسبة المؤية أكبر من 100\', !(obj.percentage>100)"},"dateConfig":{},"if":null,"disabledIf":"obj.claimantshareStatement != 1","dataGridConfig":null}',
            'description': 'نسبة مئوية',
            'fields': [],
          },
          {
            'typeId': 2,
            'name': 'discussedspace',
            'label': 'مساحة مشاعة',
            'columnSize': 3,
            'sortIndex': 16,
            'properties': '{"validations":{"conditionalRequired":"obj.claimantshareStatement == 2"},"dateConfig":{},"disabledIf":"obj.claimantshareStatement != 2","dataGridConfig":null}',
            'description': 'مساحة مشاعة',
            'fields': [],
          },
        ],
      },
    };
  },
  computed: {
    locales() {
      return this.local.dynamicFormAdmin.customComponents.BuildingInfo;
    },
    isCheckButtonDisabled() {
      return (
        !this.formModel.deedId ||
        !this.formModel.deedDate ||
        this.isChecking
      );
    },
    isCheckButtonVisible() {
      return !this.isRetrieved || this.isChecking;
    },
    isFieldDisabled() {
      return this.isManual || this.isChecking;
    },
  },
  mounted() {
    if (this.formModel.objectKey) {
      this.isRetrieved = true;
    }
  },
  methods: {
    ...mapGlobalActions(['getRealEstateDeedInfo']),
    check() {
      this.isChecking = true;
      this.resetFlags();

      this.getRealEstateDeedInfo({
        deedId: this.formModel.deedId,
        deedDate: this.formModel.deedDate,
      })
        .then((res) => {
          if (res.data) {
            this.isRetrieved = true;
            const deedInfoResult = res.data.deedInfo;

            const mappedData = {
              objectKey: deedInfoResult.deedNumber,
              instrumentNumber: deedInfoResult.deedNumber,
              instrumentDate: this.formModel.deedDate,
              pieceNumber: this.getPieceNumber(deedInfoResult),
              blockNumber: this.getBlockNumber(deedInfoResult),
              organizationalChartNumber: deedInfoResult.deedSerial,
              space: deedInfoResult.deedArea,
              discussedspace: deedInfoResult.deedArea,
              district: deedInfoResult.neighborhood,
              city: deedInfoResult.deedCityName,
              source: deedInfoResult.deedCourtName,
              ownerName: this.getOwnerName(res.data),
              percentage: null,
              cityType: null,
              claimantshareStatement: null,
              measurement: null,
              measurementText: null,
            };
            Object.keys(mappedData)
              .map((key) => {
                this.$set(this.formModel, key, mappedData[key]);
                return key;
              });
          }
        })
        .catch(() => {
          this.isManual = true;
          this.toaster.error(this.local.common.noData);
          this.clearFormData();
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
    resetFlags() {
      this.isRetrieved = false;
      this.isManual = false;
    },
    deedDateChanged() {
      this.resetFlags();
    },
    deedIdChanged() {
      this.resetFlags();
      this.formModel.deedDate = null;
      this.clearFormData();
    },
    getPieceNumber(deedInfo) {
      if (!deedInfo.planNumber) {
        return null;
      }
      return deedInfo.planNumber.split('/')[0];
    },
    getBlockNumber(deedInfo) {
      if (!deedInfo.planNumber) {
        return null;
      }
      return deedInfo.planNumber.split('/')[1];
    },
    getOwnerName(apiData) {
      if (apiData.ownersInformation && apiData.ownersInformation.length > 0) {
        return apiData.ownersInformation[0].ownerName;
      }
      return null;
    },
    clearFormData() {
      const mappedData = {
        objectKey: null,
        instrumentNumber: null,
        instrumentDate: null,
        pieceNumber: null,
        blockNumber: null,
        organizationalChartNumber: null,
        space: null,
        discussedspace: null,
        district: null,
        city: null,
        source: null,
        ownerName: null,
        percentage: null,
        cityType: null,
        claimantshareStatement: null,
        measurement: null,
        measurementText: null,
      };
      Object.keys(mappedData)
        .map((key) => {
          this.$set(this.formModel, key, mappedData[key]);
          return key;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>